import { Typography } from 'antd'
import React from 'react'
import Invoices from './Invoices'
import Refunds from './Refunds'

type Props = {
  workspaceId: number
}

/**
 * 구독·결제 묶음 (aipark-front #266)
 *
 * 결제 건 목록과 환불대장은 한 화면에 연달아 있어야 한다 — 결제 건의 `기록 보기` 가 대장의
 * 해당 행으로 이동하기 때문이다.
 *
 * 와이어프레임은 이것을 "구독·결제 **탭**" 으로 그렸지만 이번 범위에서는 탭을 만들지 않는다
 * (#267 로 분리). `workspaceId` 하나만 받는 자족적인 묶음이라, 탭을 도입할 때 이 컴포넌트를
 * `<Tabs.TabPane>` 안으로 그대로 옮기면 된다.
 */
export default function SubscriptionPayment({ workspaceId }: Props) {
  // 결제 건 목록에서 `기록 보기` 를 누르면 대장의 그 행으로 이동한다. 상태를 여기 두는 것은
  // 두 자식이 공유하는 유일한 값이기 때문이다 — 더 올리면 페이지 전체가 다시 그려진다.
  const [highlightRefundId, setHighlightRefundId] = React.useState<number | null>(null)

  const showRefundRow = (refundId: number) => {
    setHighlightRefundId(refundId)
    document.getElementById(`refund-row-${refundId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    <section style={{ marginBottom: 20 }}>
      <Typography.Title level={3}>구독·결제</Typography.Title>
      <Invoices workspaceId={workspaceId} onShowRefundRow={showRefundRow} />
      <Refunds workspaceId={workspaceId} highlightRefundId={highlightRefundId} />
    </section>
  )
}
